<template>
  <ul class="myUL">
    <li v-for="(item, index) in data" :key="index">
      <span v-if="item.children" class="tree-row"><span class="expand-icon" style="margin-right: 10px;"><i class="el-icon-caret-bottom" /></span><span class="parent-row" @click="parentClicked(item)">{{ item.name }}</span>
        <ul v-if="item.children.length > 0" class="nested active">
          <multiple-tree-data :data="item.children" @valueChanged="onValueChanged" />
        </ul>
      </span>
      <span v-else class="children-row" @click="childrenClicked(item)">{{ item.name }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MultipleTreeData',
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      test: false
    }
  },
  mounted() {
    var toggler = document.getElementsByClassName('expand-icon')
    var i

    for (i = 0; i < toggler.length; i++) {
      toggler[i].addEventListener('click', function() {
        this.parentElement.querySelector('.nested').classList.toggle('active')
        this.classList.toggle('caret-down')
      })
    }
  },
  methods: {
    onValueChanged(data) {
      this.$emit('valueChanged', data)
    },
    parentClicked(data) {
      this.$emit('valueChanged', data)
    },
    childrenClicked(data) {
      this.$emit('valueChanged', data)
    }
  }
}
</script>

<style lang="scss">
ul, .myUL {
  list-style-type: none;
}

li {
  cursor: pointer;
  user-select: none;
  // background-color: blue
}

.myUL {
  margin: 0;
  padding: 0;
}

.caret {
  cursor: pointer;
  -webkit-user-select: none; /* Safari 3.1+ */
  -moz-user-select: none; /* Firefox 2+ */
  -ms-user-select: none; /* IE 10+ */
  user-select: none;
}

.expand-icon {
  cursor: pointer;
  user-select: none
}

.caret-down {
  i {
    transform: rotate(180deg)
  }
}

// .caret::before {
//   content: "\25B6";
//   color: black;
//   display: inline-block;
//   margin-right: 6px;
// }

// .caret-down::before {
//   -ms-transform: rotate(90deg); /* IE 9 */
//   -webkit-transform: rotate(90deg); /* Safari */
//   transform: rotate(90deg);
// }

.nested {
  display: none;
}

.active {
  display: block;
}

.tree-row {
  // border: 1px solid red !important;
  display: inline-block;
  // height: 40px;
}
.parent-row {
  // background: green;
  display: inline-block;
  height: 24px;
  &:hover {
    border: 2px solid grey;
    background: pink
  }
}
.children-row {
  display: inline-block;
  height: 24px;
  &:hover {
    border: 2px solid grey;
    background: pink
  }
  // background: red
}
</style>
